import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Panel} from 'react-bootstrap';
import {isEmpty} from 'lodash/lang';
import {SecondaryNavigation} from 'components/Navigation';
import SubscriptionOverview from '../Subscription/SubscriptionOverview';
import SchoolAssignedSubscriptionList from '../Subscription/SchoolAssignedSubscriptionList';
import SubscriptionList from '../Subscription/SubscriptionList';
import {fetchSchool} from 'actions/schools';
import {addFlashMessage} from 'actions/flash-message';
import {formatErrors} from 'actions/errors';
import * as permissions from 'utils/permissions';

class SchoolSubscriptionList extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };
  static propTypes = {
    role: PropTypes.string.isRequired,
    school: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      assignedSubscriptionListKey: 0,
    };
    this.fetchSchool = this.fetchSchool.bind(this);
    this.handleSubscriptionCountUpdate = this.handleSubscriptionCountUpdate.bind(this);
  }

  componentDidMount() {
    this.fetchSchool();
  }

  fetchSchool() {
    const {schoolId, fetchSchool, formatErrors} = this.props;
    fetchSchool(schoolId).catch((err) => formatErrors(err, '/schools'));
  }

  handleSubscriptionCountUpdate() {
    this.fetchSchool();
    this.setState((prevState) => ({
      assignedSubscriptionListKey: prevState.assignedSubscriptionListKey + 1,
    }));
  }

  render() {
    const {assignedSubscriptionListKey} = this.state;
    const {schoolId, role, school} = this.props;
    if (isEmpty(school)) {
      return null;
    }
    return (
      <div>
        <SecondaryNavigation hasBack />
        <div className="container content-box">
          <Panel>
            <SubscriptionOverview
              urlPrefix={permissions.isSchoolCoordinatorOrTeacher(role) ? '' : `/schools/${schoolId}`}
              activatedSubscriptions={school.activatedSubscriptions}
              pendingSubscriptions={school.pendingSubscriptions}
              allocatedSubscriptions={school.allocatedSubscriptions}
              purchasedSubscriptions={school.purchasedSubscriptions}
              hideViewDetail
            />
          </Panel>
        </div>
        {(permissions.isKluwellAdmin(role) || permissions.isSchoolCoordinator(role)) && (
          <SchoolAssignedSubscriptionList
            key={assignedSubscriptionListKey}
            schoolId={schoolId}
            fetchSchool={this.fetchSchool}
          />
        )}
        <SubscriptionList
          schoolId={schoolId}
          onSubscriptionCountUpdate={this.handleSubscriptionCountUpdate}
          hideSchool
        />
      </div>
    );
  }
}

export default connect(
  (state, ownProps) => {
    const {match} = ownProps;
    const {account, schools} = state;
    const user = account.get('user').toJS();
    const schoolId = isEmpty(user.activeSchool) ? match.params.schoolId : user.activeSchool.id;
    return {
      schoolId: parseInt(schoolId),
      role: account.getIn(['user', 'role']),
      school: schools.get('currentSchool').toJS(),
    };
  },
  {
    addFlashMessage,
    formatErrors,
    fetchSchool,
  },
)(SchoolSubscriptionList);
